import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userInfoWrapper: {
    ...theme.mixins.appContainer,
    display: 'flex',
    gap: 8,
    marginBottom: 8,
  },

  avatar: {},

  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  description: {
    color: theme.palette.text.secondary,
  },
  stats: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: `${theme.spacing(1)} 0`,
    color: theme.palette.text.secondary,
    flexWrap: 'wrap',
  },
  statsValue: {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },

  userDetailsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  userPostsWrapper: {
    flex: 2,
  },
  userRelationsWrapper: {
    width: '100% !important',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: 1,
  },

  userRelationsContainer: {
    ...theme.mixins.appContainer,
  },

  userRelationsHeader: {
    display: 'flex',
    gap: 8,
    color: theme.palette.text.primary,
    textDecoration: 'unset',

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },

  userRelationsTitle: {
    ...theme.mixins.appEllipsis,
    fontWeight: 600,
    margin: '8px 0 8px 8px',
    fontSize: 14,
  },

  userRelationsCounter: {
    fontWeight: 600,
    marginLeft: theme.spacing(0.5),
    color: theme.palette.grey[600],
  },
}));
